export type Selection = {
  start: number;
  end: number;
  length: number;
  value: string;
};

/**
 * Get text selection on an input
 */
export function getSelection(element: any): Selection | null {
  let length;

  if (typeof element.selectionStart !== 'undefined') {
    length = element.selectionEnd - element.selectionStart;
    return {
      start: element.selectionStart,
      end: element.selectionEnd,
      length: length,
      value: element.value.substr(element.selectionStart, length)
    };
  }

  return null;
}

/**
 * Set text selection on a dom element
 *
 * @see https://developer.mozilla.org/fr/docs/Web/API/HTMLInputElement/setSelectionRange
 */
export function setSelection(
  element: HTMLInputElement,
  selection: { start: number; end: number }
): void {
  element.setSelectionRange(selection.start, selection.end);
  element.focus();
}
